 
import Informations from '../modals/Informations';  
import GoBackInfo from '../modals/GoBackInfo';
import GenerateReport from '../modals/GenerateReport';
import MessagesSnackbar from '../../../components/shared/MessagesSnackbar';
import { useContext } from 'react';
import { ReportBuilderValues, ReportsBuilderContext } from '../context/ReportsBuilderContext';
import ConfirmSave from '../modals/ConfirmSave';

const ReportBuilderPopUps=() => {  
  const { closeSnackBar,
    isSnackBarOpen,
    snackBarSeverity,
    snackbarMessage } = useContext(ReportsBuilderContext) as ReportBuilderValues;
  return (
    <>
      <Informations/> 
      <GoBackInfo/>
      <GenerateReport/>
      <ConfirmSave/>
      <MessagesSnackbar onClose={closeSnackBar}
        open={isSnackBarOpen}
        severity={snackBarSeverity}
        message={snackbarMessage}
        duration={null}/>
    </>
  );
};

export default ReportBuilderPopUps;